

export const contentDict = {
  title: "Example Blog Post About Nothing Really",                // Display name
  finishDate: new Date("2023-04-08"),     // format is YYYY-MM-DD
  description: 
    `This example blog post's sole purpose is to have a default post.js file 
    within the data folder that you can modify as a template for actual projects.`,
  tags: ["Example", "Template", "Project"],
  authors: ["Philipp Wulff"],
  coverImage: require('./img1.jpg'),
  markdownFile: require('./post.md'),
  parentDirName: "example",             // Required to resolve img paths.    
  citations: null,                      // optionally `require(citations.bib)`
  hidden: true,
};

export default contentDict;